// Public entry point for the Order Rules Analytics API layer.
// The implementation is split across sibling modules by concern:
//   types.ts                       — all request/response TypeScript interfaces
//   requestBuilder.ts               — shared POST-body builder + payload unwrapping
//   summaryApi.ts                   — Executive Overview summary + KPI cards
//   chartsApi.ts                    — Max Potential / Enrollment / Layer Performance charts
//   filterDataApi.ts                — filter-bar dropdown data + autocomplete
//   recommendationsApi.ts           — SKU Recommendations + Open Recommendations
//   orderRuleCheckApi.ts            — Order Rule Check (build + cross-dock) + review toggle
//   maxPotentialExecutionApi.ts     — Max Potential Execution table
//   customerSkuUtilizationApi.ts    — Customer & SKU Utilization
//   salesVolumeApi.ts               — Sales Details / average weekly sales volume
//   lastRefreshApi.ts               — last-refresh timestamp lookup
//   deprecated.ts                   — legacy fetchOrderRulesDashboard shim
// Every symbol previously exported from the single orderRulesApi.ts file is
// re-exported here so existing `from '../orderRulesApi'` imports keep working.

export * from './types';
export * from './requestBuilder';
export * from './summaryApi';
export * from './chartsApi';
export * from './filterDataApi';
export * from './recommendationsApi';
export * from './orderRuleCheckApi';
export * from './maxPotentialExecutionApi';
export * from './customerSkuUtilizationApi';
export * from './salesVolumeApi';
export * from './lastRefreshApi';
export * from './exportApi';
export * from './deprecated';
